/* ════════════════════════════════════════════════════════════════
   THE PINE STRAW SHOPPE — shoppe.js
   Global interactions only. Section-specific behaviour (coverage
   calculator, product buy box) ships inside those sections.
   ES5 / vanilla, presence-guarded so it no-ops where unused.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Shared cart helpers ───────────────────────────────── */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    v = parts.join('.');
    if (v.slice(-3) === '.00') v = v.slice(0, -3);
    return '$' + v;
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function updateCartCount(n) {
    var cartBtn = document.querySelector('.cart-btn');
    if (!cartBtn) return;
    var c = cartBtn.querySelector('.cart-count');
    if (n > 0) {
      if (!c) {
        c = document.createElement('span');
        c.className = 'cart-count';
        cartBtn.appendChild(c);
      }
      c.textContent = n;
    } else if (c) {
      cartBtn.removeChild(c);
    }
  }

  /* ── Mobile menu toggle ──────────────────────────────── */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close after tapping a link
    var links = nav.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* ── Cart drawer ───────────────────────────────────────
     Slide-out cart. Renders from /cart.js so it always matches the
     live cart. Quantity edits hit /cart/change.js; discount codes
     apply through /cart/update.js `discount` (Cart AJAX API).      */
  var Drawer = (function () {
    var drawer, overlay, elItems, elEmpty, elFoot, elCount, elSummary,
        elChips, elMsg, elInput, elApply, elCheckout, elDockNote;
    var isOpen = false;
    var busy = false;

    function q(sel) { return document.querySelector(sel); }

    function present() {
      drawer = q('[data-cart-drawer]');
      if (!drawer) return false;
      overlay = q('[data-cart-overlay]');
      elItems = q('[data-drawer-items]');
      elEmpty = q('[data-drawer-empty]');
      elFoot = q('[data-drawer-foot]');
      elCount = q('[data-drawer-count]');
      elSummary = q('[data-drawer-summary]');
      elChips = q('[data-drawer-discount-chips]');
      elMsg = q('[data-drawer-discount-msg]');
      elInput = q('[data-drawer-discount-input]');
      elApply = q('[data-drawer-discount-apply]');
      elCheckout = q('[data-drawer-checkout]');
      elDockNote = q('[data-drawer-dock-note]');
      return true;
    }

    function setMsg(text, ok) {
      if (!elMsg) return;
      if (!text) { elMsg.hidden = true; return; }
      elMsg.hidden = false;
      elMsg.textContent = text;
      elMsg.className = 'drawer-discount-msg' + (ok ? ' ok' : ' err');
    }

    function variantLine(item) {
      var vt = item.variant_title;
      if (!vt || vt.indexOf('Default') !== -1) return '';
      var parts = vt.split(' / ');
      var out = escapeHtml(parts[0]) + ' delivery';
      if (parts[1] && parts[1] !== '1') out += ' &middot; ' + escapeHtml(parts[1]) + '-pallet bundle';
      return '<div class="cart-item-variant">' + out + '</div>';
    }

    function propsList(item) {
      var out = '';
      var props = item.properties || {};
      for (var k in props) {
        if (!props.hasOwnProperty(k)) continue;
        if (!props[k] || k.charAt(0) === '_') continue;
        out += '<li>' + escapeHtml(k) + ': ' + escapeHtml(props[k]) + '</li>';
      }
      return out ? '<ul class="cart-item-props">' + out + '</ul>' : '';
    }

    function lineDiscounts(item) {
      var allocs = item.line_level_discount_allocations || [];
      if (!allocs.length) return '';
      var out = '';
      for (var i = 0; i < allocs.length; i++) {
        var app = allocs[i].discount_application || {};
        out += '<span class="line-discount-tag">' + escapeHtml(app.title || 'Discount') +
               ' (&minus;' + money(allocs[i].amount) + ')</span>';
      }
      return '<div class="line-discounts">' + out + '</div>';
    }

    function priceCell(item) {
      if (item.original_line_price !== item.final_line_price) {
        return '<div class="cart-item-price"><s>' + money(item.original_line_price) + '</s> ' +
               money(item.final_line_price) + '</div>';
      }
      return '<div class="cart-item-price">' + money(item.final_line_price) + '</div>';
    }

    function itemHtml(item) {
      var img = item.image
        ? '<img src="' + item.image + (item.image.indexOf('?') === -1 ? '?width=180' : '&width=180') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '<div class="img-ph"></div>';
      return '' +
        '<div class="drawer-item" data-line-key="' + escapeHtml(item.key) + '">' +
          '<div class="cart-item-img">' + img + '</div>' +
          '<div class="cart-item-info">' +
            '<a href="' + escapeHtml(item.url) + '" class="cart-item-title">' + escapeHtml(item.product_title) + '</a>' +
            variantLine(item) +
            propsList(item) +
            lineDiscounts(item) +
            '<button type="button" class="cart-item-remove" data-drawer-remove>Remove</button>' +
          '</div>' +
          '<div class="drawer-item-row">' +
            '<div class="stepper stepper-sm">' +
              '<button type="button" data-drawer-qty="-1" aria-label="Decrease">&minus;</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-drawer-qty-input aria-label="Quantity">' +
              '<button type="button" data-drawer-qty="1" aria-label="Increase">+</button>' +
            '</div>' +
            priceCell(item) +
          '</div>' +
        '</div>';
    }

    function summaryHtml(cart) {
      var out = '<div class="sum-row"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>';
      var apps = cart.cart_level_discount_applications || [];
      for (var i = 0; i < apps.length; i++) {
        out += '<div class="sum-row sum-discount"><span>Discount &middot; ' + escapeHtml(apps[i].title || 'Discount') +
               '</span><span>&minus;' + money(apps[i].total_allocated_amount) + '</span></div>';
      }
      if (cart.total_discount > 0) {
        out += '<div class="sum-row sum-savings"><span>You\u2019re saving</span><span>' + money(cart.total_discount) + '</span></div>';
      }
      out += '<div class="sum-row sum-total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
      return out;
    }

    function applicableCodes(cart) {
      var codes = [];
      var dc = cart.discount_codes || [];
      for (var i = 0; i < dc.length; i++) {
        if (dc[i].applicable) codes.push(dc[i].code);
      }
      return codes;
    }

    function chipsHtml(cart) {
      var codes = applicableCodes(cart);
      var out = '';
      for (var i = 0; i < codes.length; i++) {
        out += '<span class="discount-chip">' + escapeHtml(codes[i]) +
               '<button type="button" data-remove-code="' + escapeHtml(codes[i]) + '" aria-label="Remove ' + escapeHtml(codes[i]) + '">&#x2715;</button></span>';
      }
      return out;
    }

    function render(cart) {
      if (!drawer) return;
      updateCartCount(cart.item_count);
      elCount.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';

      if (cart.item_count === 0) {
        elEmpty.hidden = false;
        elItems.innerHTML = '';
        elFoot.hidden = true;
        return;
      }
      elEmpty.hidden = true;
      elFoot.hidden = false;

      var html = '';
      for (var i = 0; i < cart.items.length; i++) html += itemHtml(cart.items[i]);
      elItems.innerHTML = html;
      elSummary.innerHTML = summaryHtml(cart);
      elChips.innerHTML = chipsHtml(cart);

      // Commercial pallets require the dock/forklift confirmation on the
      // cart page — route checkout through it rather than around it.
      var hasCommercial = false;
      for (var j = 0; j < cart.items.length; j++) {
        if ((cart.items[j].variant_title || '').indexOf('Commercial') !== -1) hasCommercial = true;
      }
      if (hasCommercial) {
        elCheckout.setAttribute('href', '/cart');
        elCheckout.textContent = 'Review & Check Out';
        elDockNote.hidden = false;
      } else {
        elCheckout.setAttribute('href', '/checkout');
        elCheckout.textContent = 'Check Out';
        elDockNote.hidden = true;
      }
    }

    function refresh() {
      return getCart().then(render);
    }

    function open() {
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.hidden = false;
      document.body.classList.add('drawer-open');
      isOpen = true;
      refresh();
    }

    function close() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
      document.body.classList.remove('drawer-open');
      isOpen = false;
    }

    function changeQty(key, qty) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        busy = false;
        render(cart);
      }).catch(function () { busy = false; refresh(); });
    }

    function postDiscounts(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) { return r.json(); });
    }

    function applyCode() {
      var code = (elInput.value || '').trim();
      if (!code || busy) return;
      busy = true;
      elApply.disabled = true;
      elApply.textContent = 'Applying\u2026';
      setMsg('');
      getCart().then(function (cart) {
        var codes = applicableCodes(cart);
        codes.push(code);
        return postDiscounts(codes);
      }).then(function (cart) {
        var dc = cart.discount_codes || [];
        var found = null;
        for (var i = 0; i < dc.length; i++) {
          if (dc[i].code.toLowerCase() === code.toLowerCase()) found = dc[i];
        }
        if (found && found.applicable) {
          setMsg('Discount applied.', true);
          elInput.value = '';
          render(cart);
          done();
        } else {
          // Not valid for this cart — strip it back out so it doesn't linger
          var keep = applicableCodes(cart);
          postDiscounts(keep).then(function (clean) {
            setMsg("That code isn't valid for this cart.", false);
            render(clean);
            done();
          });
        }
      }).catch(function () {
        setMsg("Couldn't apply that code — please try again.", false);
        done();
      });
      function done() {
        busy = false;
        elApply.disabled = false;
        elApply.textContent = 'Apply';
      }
    }

    function removeCode(code) {
      if (busy) return;
      busy = true;
      getCart().then(function (cart) {
        var keep = [];
        var codes = applicableCodes(cart);
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].toLowerCase() !== code.toLowerCase()) keep.push(codes[i]);
        }
        return postDiscounts(keep);
      }).then(function (cart) {
        busy = false;
        setMsg('');
        render(cart);
      }).catch(function () { busy = false; refresh(); });
    }

    function bind() {
      // Header cart button opens the drawer everywhere except the cart
      // page itself, where the full page is already the cart.
      var onCartPage = document.body.className.indexOf('template-cart') !== -1;
      var btn = document.querySelector('[data-cart-toggle]');
      if (btn && !onCartPage) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          open();
        });
      }

      var closers = document.querySelectorAll('[data-cart-close]');
      for (var i = 0; i < closers.length; i++) {
        closers[i].addEventListener('click', close);
      }
      overlay.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) close();
      });

      elApply.addEventListener('click', applyCode);
      elInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyCode(); }
      });
      elChips.addEventListener('click', function (e) {
        var b = e.target.closest('[data-remove-code]');
        if (b) removeCode(b.getAttribute('data-remove-code'));
      });

      // Line item interactions (delegated — items re-render often)
      elItems.addEventListener('click', function (e) {
        var row = e.target.closest('[data-line-key]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        var stepBtn = e.target.closest('[data-drawer-qty]');
        if (stepBtn) {
          var input = row.querySelector('[data-drawer-qty-input]');
          var v = (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-drawer-qty'), 10);
          if (v < 0) v = 0;
          changeQty(key, v);
          return;
        }
        if (e.target.closest('[data-drawer-remove]')) changeQty(key, 0);
      });
      elItems.addEventListener('change', function (e) {
        var input = e.target.closest('[data-drawer-qty-input]');
        if (!input) return;
        var row = input.closest('[data-line-key]');
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        changeQty(row.getAttribute('data-line-key'), v);
      });
    }

    function init() {
      if (!present()) return;
      bind();
    }

    return { init: init, open: open, refresh: refresh };
  })();

  /* ── FAQ accordion ───────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var q = item.querySelector('[data-faq-q]');
        if (!q) return;
        q.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          // Close siblings within the same list for a tidy single-open feel
          var list = item.parentNode;
          var siblings = list.querySelectorAll('[data-faq-item]');
          for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('open');
          if (!isOpen) item.classList.add('open');
        });
      })(items[i]);
    }
  }

  /* ── Grid visibility: format filter × needle toggle ──────── */
  function applyGridVisibility() {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var f = 'all';
    var fb = document.querySelector('[data-filter-bar] button.active');
    if (fb) f = fb.getAttribute('data-filter');
    var nb = document.querySelector('[data-needle-view].active');
    var n = nb ? nb.getAttribute('data-needle-view') : null;
    var cards = grid.querySelectorAll('[data-format]');
    for (var j = 0; j < cards.length; j++) {
      var fMatch = (f === 'all') || (cards[j].getAttribute('data-format') === f);
      var nMatch = !n || !cards[j].hasAttribute('data-needle') || (cards[j].getAttribute('data-needle') === n);
      cards[j].style.display = (fMatch && nMatch) ? '' : 'none';
    }
  }

  /* ── Product filter (Boxes / Pallets / All) ──────────────── */
  function initFilter() {
    var bar = document.querySelector('[data-filter-bar]');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var btns = bar.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
      btn.classList.add('active');
      applyGridVisibility();
    });
  }

  /* ── Needle toggle (Longleaf / Slash) ─────────────────────── */
  function initNeedleView() {
    var btns = document.querySelectorAll('[data-needle-view]');
    if (!btns.length) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        var b = e.currentTarget;
        for (var j = 0; j < btns.length; j++) {
          btns[j].classList.remove('active');
          btns[j].setAttribute('aria-pressed', 'false');
        }
        b.classList.add('active');
        b.setAttribute('aria-pressed', 'true');
        applyGridVisibility();
      });
    }
    applyGridVisibility(); /* default view: longleaf only */
  }

  /* ── Delivery view toggle (res/com pallet pricing on grids) ── */
  var DELIVERY_DESC = {
    res: '<strong>Residential</strong> \u2014 liftgate truck with a scheduled delivery appointment and curbside drop-off. The right choice for homes and driveways.',
    com: '<strong>Commercial</strong> \u2014 requires a loading dock or forklift to unload. Prices shown are commercial delivery.'
  };

  function currentDeliveryMode() {
    var btns = document.querySelectorAll('[data-delivery-view]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains('active')) return btns[i].getAttribute('data-delivery-view');
    }
    return 'res';
  }

  function initDeliveryView() {
    var btns = document.querySelectorAll('[data-delivery-view]');
    if (!btns.length) return;
    function apply(mode) {
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-delivery-view') === mode;
        btns[i].classList.toggle('active', on);
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var amts = document.querySelectorAll('[data-price-res]');
      for (var j = 0; j < amts.length; j++) {
        amts[j].textContent = amts[j].getAttribute(mode === 'com' ? 'data-price-com' : 'data-price-res');
      }
      var tags = document.querySelectorAll('[data-dock-tag]');
      for (var k = 0; k < tags.length; k++) tags[k].hidden = (mode !== 'com');
      var desc = document.querySelector('[data-delivery-desc]');
      if (desc) {
        desc.innerHTML = DELIVERY_DESC[mode];
        desc.classList.toggle('dd-com', mode === 'com');
      }
    }
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        apply(e.currentTarget.getAttribute('data-delivery-view'));
      });
    }
  }

  /* ── Grid quick-add (Add to Cart on product cards) ─────────── */
  function initQuickAdd() {
    var buttons = document.querySelectorAll('[data-add-to-cart]');
    if (!buttons.length) return;
    var modal = document.getElementById('gridCommModal');
    var pendingBtn = null;

    function addItem(vid, btn) {
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { 'Ship-out date': 'Earliest available' } }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = 'Added \u2713';
        Drawer.open();
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 1600);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
        alert("Couldn't add to cart \u2014 please try the product page.");
      });
    }

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var isPallet = btn.getAttribute('data-is-pallet') === 'true';
        if (isPallet && currentDeliveryMode() === 'com' && modal) {
          pendingBtn = btn;
          modal.hidden = false;
          return;
        }
        addItem(btn.getAttribute(isPallet && currentDeliveryMode() === 'com' ? 'data-vid-com' : 'data-vid-res'), btn);
      });
    }

    if (modal) {
      document.getElementById('gridCommConfirm').addEventListener('click', function () {
        modal.hidden = true;
        if (pendingBtn) addItem(pendingBtn.getAttribute('data-vid-com'), pendingBtn);
        pendingBtn = null;
      });
      function cancelModal() { modal.hidden = true; pendingBtn = null; }
      document.getElementById('gridCommCancel').addEventListener('click', cancelModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) cancelModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) cancelModal(); });
    }
  }

  function init() { initMenu(); Drawer.init(); initFaq(); initFilter(); initNeedleView(); initDeliveryView(); initQuickAdd(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
